import LogoutIcon from "@mui/icons-material/LogoutOutlined";
import {
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { useColorScheme } from "@mui/material/styles";
import { Link as RouterLink } from "react-router";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import UserContext from "../../context/UserContext";
import { pageRoutes } from "../../routes";

interface Props {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

const UserMenu = ({ open, anchorEl, onClose }: Props) => {
  const { userInfo } = useDefinedContext(UserContext);
  const { mode, setMode } = useColorScheme();

  return (
    <Menu
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: 40, vertical: 50 }}
      slotProps={{ paper: { sx: { width: "18rem", px: 1 } } }}
    >
      <Stack spacing={0.5} sx={{ px: 2 }}>
        <Typography variant="subtitle2">{userInfo.name}</Typography>
        {userInfo.email && <Typography>{userInfo.email}</Typography>}
      </Stack>
      <Divider sx={{ my: 1 }} />
      <Stack spacing={1} sx={{ px: 2 }}>
        <Typography variant="subtitle2">Color Scheme</Typography>
        <ToggleButtonGroup exclusive value={mode} onChange={(_, value) => setMode(value)} fullWidth>
          <ToggleButton key="system" value="system">
            System
          </ToggleButton>
          <ToggleButton key="light" value="light">
            Light
          </ToggleButton>
          <ToggleButton key="dark" value="dark">
            Dark
          </ToggleButton>
        </ToggleButtonGroup>
      </Stack>
      <Divider sx={{ my: 1 }} />
      <MenuItem component={RouterLink} to={`/${pageRoutes.logout}`}>
        <ListItemIcon>
          <LogoutIcon />
        </ListItemIcon>
        <ListItemText>Logout</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default UserMenu;
